import { Button, IconButton, Typography } from '@mui/material'
import React from 'react'
import PrintIcon from '@mui/icons-material/Print';
import { usePerfil } from 'useAuth';

import * as OkReportGerador from '../../OkReportGerador';
export default function ItemRelatorio({ fav, modelo, dados, prepareDados, aoGerar }) {
    const perfil = usePerfil();
    const emiteRelatorio = () => {
        console.log('emiteRelatorio modelo', modelo)
        console.log('emiteRelatorio dados', dados)
        let metaUsar = { perfil }
        if (prepareDados) {
            prepareDados(dados).then((dadosP) => {
                console.log('dadosP', dadosP)
                OkReportGerador.imprimirDados(modelo, dados, metaUsar)
                if (aoGerar) aoGerar();
            })
        } else {
            OkReportGerador.imprimirDados(modelo, dados, metaUsar)
            if (aoGerar) aoGerar();

        }
    }
    if (fav) {
        return (
            <IconButton size="small" onClick={emiteRelatorio}>
                <PrintIcon />
            </IconButton>
        )
    } else {


        return (
            <div style={{ display: 'flex', justifyContent: "center" }}>
                <div style={{ flex: 1 }}>
                    <Typography variant="h6">
                        {modelo.nome}
                    </Typography>
                    <Typography variant="subtitle1">
                        {modelo.descricao}
                    </Typography>
                </div>
                <div style={{ display: 'flex', alignItems: "center", flex: 0 }}>

                    <Button variant='contained' color='primary' onClick={emiteRelatorio}>Emitir</Button>
                </div>
            </div>
        )
    }
}
